import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const getAll = async (data) => (
  axiosRequest({
    url: '/v1/exportRule/findAll',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const findById = async (data) => (
  axiosRequest({
    url: '/v1/exportRule/findById',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export {
  getAll,
  findById,
};
